import React from 'react'
import MenuItem from './MenuItem'

export default function NestedList({ items, depth = 0 }) {
    return (
        <ul>
            {items.map(item =>
                item?.wpChildren && item.children.length > 0 ? (
                    <MenuItem item={item} depth={depth} key={item.id}>
                        <NestedList items={item.children} depth={depth + 1} />
                    </MenuItem>
                ) : (
                    <MenuItem item={item} depth={depth} key={item.id} />
                ),
            )}
        </ul>
    )
}
